import DataDisplayRowI from "../DataDisplayRowI";
import getAllItemRow from "../DataDisplayRow/AllItemRow";
import DataDisplayTable from "../DataDisplayTable";

class AllItemTable extends DataDisplayTable {
    #row!: DataDisplayRowI;

    generateRow(): DataDisplayRowI {
        return this.#row = getAllItemRow()
    }
}

let allItemTable: AllItemTable | null = null;

export default function getAllItemTable(): AllItemTable {
    if (allItemTable === null)
        allItemTable = new AllItemTable()
    return allItemTable
}